// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge.badge-pill[data-v-ff32ab66]{height:2rem;display:inline-flex;align-items:center}.global-loader[data-v-ff32ab66]{position:absolute;width:100%;height:100%;display:flex;justify-content:center;align-items:center;z-index:2;min-height:100vh}", ""]);
// Exports
module.exports = exports;
